import { $1, $e } from './utils';
var loaded = false;
var guid = 0;
if ($1('.tinymce')) {
    initTinyMCE();
}
document.body.addEventListener('tinymceinit', function (ev) {
    if (!loaded)
        initTinyMCE();
    else {
        var elem = ev.target;
        if (!elem.id)
            elem.id = "tinymce-guid-".concat(++guid);
        init("[id=\"".concat(elem.id, "\"]"));
    }
});
function initTinyMCE() {
    var script = $e('script', { src: '/js/tinymce/tinymce.min.js', async: true });
    script.addEventListener('load', function () { return init('.tinymce'); });
    document.head.append(script);
    loaded = true;
}
function init(selector) {
    tinymce.init({
        selector: selector,
        plugins: 'code table lists link',
        toolbar: 'undo redo | blocks | bold italic | alignleft aligncenter alignright | link | bullist numlist | code | table',
        inline: true,
        link_default_protocol: 'https',
        relative_urls: false,
    });
}
